// M004-F0622 / T-M004-0032 (WebUI, first-invoice trace, booking 3218):
// `<input type="datetime-local">` has no timezone concept at all — whatever
// digits you put in are read back out verbatim as a naive "YYYY-MM-DDTHH:mm"
// string with no offset. The browser's own `new Date(naiveString)` parses
// that string as the RUNNING BROWSER'S LOCAL time (ECMA-262 date-time string
// format without a timezone offset). Any booking-edit dialog that formats the
// input's initial value with `date.toISOString().slice(0, 16)` (UTC digits)
// but then saves via `new Date(editForm.start_time).toISOString()` (local
// parse) has an ASYMMETRIC round trip: the digits shown are UTC, but the
// digits are re-interpreted as local on save — shifting the stored instant by
// exactly the caller's UTC offset (one hour for BST) on every edit, including
// a genuine no-op edit where the user changed nothing.
//
// The fix is symmetry, not "the right timezone": build the datetime-local
// value from the SAME local-time interpretation `new Date(str)` will apply
// when the form is submitted, using local Date getters (never
// `toISOString()`/UTC getters) for the load side. A load→no-edit→save round
// trip is then lossless in whatever timezone the browser is running,
// including across a DST boundary, because both directions agree on "local".
export function formatDateForLocalInput(dateInput) {
  const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
  if (Number.isNaN(date.getTime())) return '';
  const pad = (n) => String(n).padStart(2, '0');
  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  return `${year}-${month}-${day}T${hours}:${minutes}`;
}
